import {TBH_RESOURCE_MANAGEMENT} from '../resources/endPoint';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../../Api/resources/serviceURLs';
import { serviceName } from '../../Api/resources/serviceConstants';

export const fetchBaseURL = () => {
  const serviceURL = appendServiceNameToURL(serviceName.LANDING_MS);
  const servicePort = appendServicePortToURL(serviceName.LANDING_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${TBH_RESOURCE_MANAGEMENT}`;
  }
  return `${baseUrl}:${servicePort}${serviceURL}/api${TBH_RESOURCE_MANAGEMENT}`;
};
